import styles from "../hero.module.css";
import { Weather } from "../../../types/variables/Variables";
import { WeatherIcon } from "../../../utils/commons/getWeatherIcon";
import CustomInput from "../../autocomplete/AutoComplete";
import { useLanguage } from "../../../components/contexts/LanguageContext";
import translations from "../../../components/translations";
import { useParams } from "../../../hooks/common/useParams";
import { useGetOUWeather } from "../../../hooks/getSelectedOuWeather/useGetSelectedOuWeather";
import { WeatherLabel } from "../../../utils/commons/returnWeatherLabel";
import Skeleton from "@mui/material/Skeleton";

const ForecastHero = () => {
    const { selectedLanguage } = useLanguage();
    const { add, useUrlParamiters } = useParams()
    const { data, loading } = useGetOUWeather();
    const { orgUnit, orgUnitName, parentId } = useUrlParamiters();

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    };

    const onChange = (e: any, r: any, defaultOu: any) => {
        add("orgUnit", r?.id ?? defaultOu?.id)
        add("orgUnitName", r?.name ?? defaultOu?.name)
        add("parentId", r?.parent?.id ?? defaultOu?.parent?.id)
    }

    return (
        <section className="weather-banner-1">
            <div className="container">
                <div className="content">
                    <form onSubmit={handleSubmit} autoComplete="off" className="mb-5">
                        <CustomInput onChange={onChange} />
                    </form>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column", rowGap: "25px" }}>
                            <div>
                                {loading ? <Skeleton variant="text" width={"300px"} height={"46px"} sx={{ p: "8px" }} />
                                    :
                                    <h2 className="fw-6 fs-40 mb-2">
                                        {data?.organisationUnit ?? orgUnitName}
                                    </h2>
                                }

                                {loading ? (
                                    <Skeleton variant="text" width={"150px"} height={"20px"} />
                                ) : (
                                    <p className="fs-16 lh-120 m-0">
                                        <WeatherLabel weather={data?.weatherIcon as Weather} selectedLanguage={selectedLanguage} />
                                    </p>
                                )}
                            </div>
                            {
                                loading ?
                                    <Skeleton variant="text" width={"250px"} height={"162px"} />
                                    :
                                    <div className="temperature d-flex">
                                        <h2 className="fw-5 fs-143 m-0">
                                            {data?.maxAirTemperature ?? "--"}
                                        </h2>
                                        <p className="fs-33 m-0 ps-2 pe-2">°</p>
                                        <div className="text-center">
                                            <span className="degree celsius">C</span>
                                        </div>
                                    </div>
                            }
                        </div>
                        <div className={styles.forecatsHeroIcon}>
                            {loading ? (
                                <Skeleton variant="circular" height={"250px"} width={"250px"} />
                            ) : (
                                <WeatherIcon weather={data?.weatherIcon as Weather} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export { ForecastHero };